module.exports = __webpack_public_path__ + "img/logo.da85c092.png";